/**
 * The Events container
 */
import React, { useEffect } from "react";
import { useWeb3React } from "@web3-react/core";
import PropTypes from "prop-types";
import { HiOutlineArrowLeft } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import arcticWallet from "../../assets/icons/arctic-wallet.svg";
import ethereumLogo from "../../assets/icons/ethereum.png";
import ConnectWallet from "../../components/ConnectWallet";
import ErrorModal from "../../components/ErrorModal";
import ContractMints from "../../components/Minting/ContractMints/ContractMints-component";
import TransactionProgressModal from "../../components/Minting/TransactionProgressModal/TransactionProgressModal-component";
import TransactionSuccessModal from "../../components/Minting/TransactionSuccessModal";
import Page from "../../components/Page";
import PageHead from "../../components/PageHead";
import ScrollToTop from "../../components/Utils/Scroll/ScrollToTop";
import { mintErrorReset } from "../../redux/contracts";
import {
  getAvailableMintTierContracts,
  listTiersForProject,
} from "../../redux/mintTiers";
import { REACT_APP_PROJECT_ID } from "../../utils/env";

/**
 * MintingSection container used as app default landing page
 */
const MintingSection = (props, context) => {
  const dispatch = useDispatch();
  const { account } = useWeb3React();

  const mintSuccess = useSelector((state) => state?.contracts?.mintSuccess);

  const mintError = useSelector((state) => state?.contracts?.mintError);

  const mintErrorMessage = useSelector(
    (state) => state?.contracts?.mintErrorMessage
  );

  const mintingInProgress = useSelector(
    (state) => state?.contracts?.mintingInProgress
  );
  const awaitingTransactionConfirmation = useSelector(
    (state) => state?.contracts?.awaitingTransactionConfirmation
  );

  const mintPending = useSelector((state) => state?.contracts?.mintPending);

  useEffect(() => {
    account &&
      dispatch(
        listTiersForProject({
          projectId: REACT_APP_PROJECT_ID,
          address: account,
        })
      );
    window.scrollTo(0, 0);
  }, [dispatch, REACT_APP_PROJECT_ID, account]);

  const mintTierIds = useSelector((state) => state?.mintTiers?.idsList);

  const contracts = useSelector((state) =>
    getAvailableMintTierContracts(state, mintTierIds)
  );

  return (
    <Page id="MintingSection" title={context.t("Purchase")}>
      <ScrollToTop />

      <Container className="mt-3 mb-5">
        <div className="mb-5 mt-3">
          <Link className="text-decoration-none text-dark fw-bold" to="/">
            <HiOutlineArrowLeft className="me-3" />
            Home
          </Link>
        </div>
        {account ? (
          <>
            <PageHead title={context.t("Purchase")} />
            {contracts.map((contractAddress) => (
              <ContractMints
                contractAddress={contractAddress}
                key={contractAddress}
              />
            ))}
          </>
        ) : (
          <Row className="justify-content-center whitelistcontent__noaccount">
            <Col md={7} className="text-center">
              <div className="mb-5 d-flex justify-content-center">
                <span
                  className="border rounded-circle text-primary d-inline-flex justify-content-center align-items-center"
                  style={{ height: "67px", width: "67px", margin: "5px" }}
                >
                  <img src={arcticWallet} width={40} />
                </span>
                <span
                  className="border rounded-circle d-inline-flex justify-content-center align-items-center"
                  style={{ height: "67px", width: "67px", margin: "5px" }}
                >
                  <img src={ethereumLogo} width={30} />
                </span>
              </div>
              <h3 className="text-dark fw-bold mt-3 mb-5">
                {context.t("Connect to Purchase the Legacy NFT")}
              </h3>
              <p className="lead whitelistcontent__paragraph">
                {context.t(
                  "Sign in with your crypto wallet or Google account to purchase the Legacy NFT. The payment can be completed with Ethereum or with your credit card."
                )}
              </p>
              <div className="d-grid gap-2 col-sm-12 col-md-6 mx-auto justify-content-sm-center">
                <ConnectWallet
                  buttonColor="primary"
                  buttonId="nav-connect-wallet"
                  block={true}
                  className="mt-5 button-width"
                />
              </div>
            </Col>
          </Row>
        )}
      </Container>
      {mintSuccess && (
        <TransactionSuccessModal
          success={mintSuccess}
          redirectUrl={`/purchase`}
          resourceType="token"
          action="minted"
        />
      )}
      <TransactionProgressModal
        transactionInProgress={mintingInProgress}
        awaitingTransactionConfirmation={awaitingTransactionConfirmation}
        transactionPending={mintPending}
      />
      {mintError &&
        mintErrorMessage?.errorMessage !== "transaction is not defined" && (
          <ErrorModal
            error={mintError}
            errorReset={mintErrorReset}
            customErrorBody={mintErrorMessage?.errorMessage}
          />
        )}
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
MintingSection.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default withRouter(MintingSection);
